// Small wrapper around GTM dataLayer for type-safe event pushes
export function pushEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
}

export function updateConsent(prefs) {
  // prefs: { analytics: bool, marketing: bool }
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", {
    ad_storage: prefs.marketing ? "granted" : "denied",
    ad_user_data: prefs.marketing ? "granted" : "denied",
    ad_personalization: prefs.marketing ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
  });
  pushEvent("consent_update", {
    consent_analytics: prefs.analytics ? "granted" : "denied",
    consent_marketing: prefs.marketing ? "granted" : "denied",
  });
}
